export const getIconSize = ({ size }) => {
    switch (size) {
        case "big":
            return `
        width: 1.25rem;
        height: 1.25rem;
      `;
        case "huge":
            return `
        width: 1.5rem;
        height: 1.5rem;
      `;
        default: // tiny, small, standard, touch
            return `
        width: 1rem;
        height: 1rem;
      `;
    }
};
export const getIconPadding = ({ size }) => {
    switch (size) {
        case "tiny":
            return `
        min-width: 2rem;
        max-height: 2rem;
      `;
        case "small":
            return `
        min-width: 2.25rem;
        max-height: 2.25rem;
      `;
        case "touch":
            return `
        min-width: 2.75rem;
        min-height: 2.75rem;
      `;
        case "big":
            return `
        min-width: 3rem;
        min-height: 3rem;
      `;
        case "huge":
            return `
        min-width: 3.75rem;
        min-height: 3.75rem;
      `;
        default: // standard
            return `
        min-width: 2.5rem;
        min-height: 2.5rem;
      `;
    }
};
export const getLinkSize = ({ size }) => {
    switch (size) {
        case "tiny":
        case "small":
        case "standard":
        case "touch":
            return `
        font-size: 0.875rem;
        line-height: 1.25rem;
      `;
        case "big":
            return `
        font-size: 1rem;
        line-height: 1.5rem;
      `;
        case "huge":
            return `
        font-size: 1.25rem;
        line-height: 1.75rem;
      `;
        default:
            return `
        font-size: 0.875rem; 
        line-height: 1.25rem;
      `;
    }
};
